import StockOperationPage from "./StockOperationPage";

export {StockOperationPage}
export default StockOperationPage
